import type { ReactNode } from 'react';
import { Badge, type BadgeTone } from './Badge';

/**
 * StatusBadge — 상태 문자열 → 일관된 tone. review_status / proposal status /
 * job status / report status 공용. 색+텍스트 동시(색맹 대응).
 */
const STATUS_TONE: Record<string, BadgeTone> = {
  // questions.review_status (6상태)
  draft: 'neutral',
  ai_reviewed: 'neutral',
  larc_pending: 'amber',
  revision_requested: 'accent',
  approved: 'sage',
  rejected: 'brick',
  // question_proposals.status
  pending: 'amber',
  accepted: 'sage',
  // jobs.status
  running: 'accent',
  succeeded: 'sage',
  failed: 'brick',
  partial: 'amber',
  cancelled: 'neutral',
  // question_reports.status
  open: 'amber',
  requeued: 'accent',
  dismissed: 'neutral',
  resolved: 'sage',
};

export interface StatusBadgeProps {
  status: string;
  label?: ReactNode;
}

export function StatusBadge({ status, label }: StatusBadgeProps) {
  return (
    <Badge variant="soft" tone={STATUS_TONE[status] ?? 'neutral'} size="sm">
      {label ?? status}
    </Badge>
  );
}
